import { useTranslation } from 'react-i18next';

import Alert from '@/components/atoms/Alert';
import { Button } from '@/components/atoms/Buttons';

import styles from './ProviderCard.module.scss';

export interface StaleBannerProps {
    stale: boolean;
    reloading: boolean;
    onReload: () => void;
}

/** Newer rows arrived under unsaved edits; reloading merges the edits on top of them. */
function StaleBanner({ stale, reloading, onReload }: StaleBannerProps) {
    const { t } = useTranslation();
    return (
        // Always mounted: a live region added together with its text is not announced.
        <div aria-live="polite">
            {stale && (
                // The wrapper is the live region, so the Alert adds none of its own. The button
                // sits in the body rather than the action slot, so on a narrow card it goes
                // under the text and its label may wrap instead of running past the card.
                <Alert tone="warning" size="small" live="off">
                    <span className={styles.staleBody}>
                        {t('providerConfig.stale.banner')}
                        <Button variant="secondary" wrap disabled={reloading} onClick={onReload}>
                            {t('providerConfig.stale.reload')}
                        </Button>
                    </span>
                </Alert>
            )}
        </div>
    );
}

export default StaleBanner;
export { StaleBanner };
